<template>
    <main class="dashboard">
        <SidebarComponent />
        <TopbarComponent />
        <router-view class="view" />
    </main>
</template>

<style scoped>
.dashboard {
    display: grid;
    grid-auto-flow: row dense;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    height: 100vh;
    background-color: var(--background-2);
}

.view {
    margin-right: 24px;
    border-radius: var(--border-radius-l) var(--border-radius-l) 0 0;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex-shrink: 0;
    overflow-y: auto;
}

@media screen and (min-width: 641px) and (max-width: 1024px) {
    .view {
        margin-right: 16px;
    }

}

@media screen and (max-width: 640px) {
    .dashboard {
        grid-template-columns: 1fr;
        height: auto;
    }

    .view {
        margin: 0px;
        padding: 24px 16px;
    }
}
</style>

<script>
import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import SidebarComponent from '@/components/SidebarComponent.vue';
import TopbarComponent from '@/components/TopbarComponent.vue';

export default {
    name: 'DashboardLayout',
    components: {
        SidebarComponent,
        TopbarComponent
    },
    setup() {
        const userLoginDataStorageInstance = userLoginDataStorage();

        return {
            userLoginDataStorageInstance
        };
    },
    data() {
        return {
            refreshTimeoutId: null,
            minutesBeforeRefresh: process.env.VUE_APP_MINUTES_BEFORE_REFRESH_TOKEN,
        };
    },
    async mounted() {
        await this.scheduleTokenRefresh(
            this.getRefreshTime()
        );
    },
    beforeUnmount() {
        if (this.refreshTimeoutId) {
            clearTimeout(this.refreshTimeoutId);
            this.refreshTimeoutId = null;
        }
    },
    methods: {
        getRefreshTime() {
            const now = Date.now();
            const timeUntilExpiration = this.userLoginDataStorageInstance.getUserTokenExp() - now;

            return timeUntilExpiration - this.minutesBeforeRefresh * 60 * 1000;
        },
        async scheduleTokenRefresh(refreshTime) {
            if (0 < refreshTime) {
                this.refreshTimeoutId = setTimeout(async () => {
                    await this.$globalEvent.refreshAuthToken();
                    this.scheduleTokenRefresh(this.getRefreshTime());
                }, refreshTime);
            }
            if (0 > refreshTime) {
                console.warn("Token is about to expire or has expired. Refreshing immediately.");

                const response = await this.$globalEvent.refreshAuthToken();
                if (response && undefined === response.error) {
                    this.scheduleTokenRefresh(this.getRefreshTime());
                }
            }
        }
    }
}
</script>

